import { render, staticRenderFns } from "./CorrectiveSamplesPreview.vue?vue&type=template&id=8444ab18&lang=pug&"
import script from "./CorrectiveSamplesPreview.vue?vue&type=script&lang=js&"
export * from "./CorrectiveSamplesPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports